// extracted by mini-css-extract-plugin
module.exports = {"moreTags":"_1vUWr","tagBar":"_1CjvE"};